import { APP_SHOW_CONFETTI } from '@pbl/pbl-react-core/lib/models/confetti';
import { DispatchMethod } from 'redux/reducers';
export const displayConfetti =
  (showConfetti = false) =>
  (dispatch: DispatchMethod) => {
    dispatch({
      type: APP_SHOW_CONFETTI,
      payload: showConfetti
    });
  };
